// extracted by mini-css-extract-plugin
module.exports = {"terms":"wap_terms__3bDbw","main":"wap_main__M8c3u"};